module.exports = __webpack_public_path__ + "static/media/alert-exclamation-icon.2050ed88.svg";